if (!customElements.get('bundle-gallery-controller')) {
  customElements.define('bundle-gallery-controller', class extends HTMLElement {
    connectedCallback() {
      customElements.whenDefined('product-info').then(() => {
        if (!this.isConnected) return;
        this.productInfo = this.closest('product-info');
        this.originalUpdate = this.productInfo.updateMedia;
        this.updateDescription(this.dataset.variantId);
        this.productInfo.updateMedia = (html) => {
          const nextController = html.querySelector('bundle-gallery-controller');
          const current = this.productInfo.querySelector('media-gallery');
          const next = html.querySelector('media-gallery');
          const first = next?.querySelector('[data-media-id]');
          if (!nextController || !current || !first) {
            throw new Error('Selected bundle is missing its image group.');
          }
          this.updateDescription(nextController.dataset.variantId);
          next.querySelectorAll('.scroll-trigger').forEach(item => item.classList.add('scroll-trigger--cancel'));
          current.replaceWith(document.importNode(next, true));
          const modal = this.productInfo.productModal?.querySelector('.product-media-modal__content');
          const nextModal = html.querySelector('product-modal .product-media-modal__content');
          if (modal && nextModal) modal.innerHTML = nextModal.innerHTML;
          this.productInfo.querySelector('media-gallery').setActiveMedia(first.dataset.mediaId, false);
          this.dataset.variantId = nextController.dataset.variantId;
        };
      });
    }

    updateDescription(id) {
      if (this.productInfo.classList.contains('purchase-redesign')) return;
      const root = this.productInfo.querySelector('[data-variant-description]');
      const panels = root?.querySelectorAll('[data-variant-copy]');
      if (!panels || ![...panels].some(panel => panel.dataset.variantId === id)) {
        throw new Error('Selected bundle is missing its description.');
      }
      root.hidden = false;
      panels.forEach(panel => { panel.hidden = panel.dataset.variantId !== id; });
    }

    disconnectedCallback() {
      if (this.productInfo && this.originalUpdate) this.productInfo.updateMedia = this.originalUpdate;
    }
  });
}

